const LoadedPost = (props) => {
    let responseObj = props.responseObj;
    //console.log("Loaded Response: ",responseObj);

    // If no post found
    if (responseObj.message) {
        return (
            <div className="error-page">
                <h1>No post found !</h1>
                <p>Make sure you've entered proper link.</p>
            </div>
        );
    }
    responseObj = responseObj.items[0];
    const storyArray = responseObj.carousel_media;
    
    // When User found and post is uploaded
    return (
        <>
            <header className="reel-header">
                <div className="reel-creator">
                    <img
                        src={responseObj.user.profile_pic_url}
                        className="profile-picture"
                        alt="profile"
                    />
                    <div className="creator-info">
                        <h3>{responseObj.user.username}</h3>
                        <p>{responseObj.user.full_name}</p>
                    </div>
                </div>
                <a
                    href={`https://instagram.com/${responseObj.user.username}`}
                    className="instagram-anchor"
                >
                    Visit Instagram
                </a>
            </header>
            <section className="story-list">
                <p className="post-caption"><strong>Post Caption: </strong> {responseObj.caption.text}</p>
                {
                    storyArray.map((element, index) => {
                        if (element.media_type === 2) {
                            return (
                                <article className="post-section">
                                    <center>
                                        <a class="downloadBtn" href={element.video_versions[0].url+"==.mp4"} download={responseObj.full_name + ".mp4"}>
                                            <button class="submitBtn"><i class="fa fa-download"></i> Download Below Video 👇 </button>
                                        </a>
                                    </center>
                                    <video className="post-media" controls>
                                        <source
                                            src={element.video_versions[0].url}
                                            type="video/webm"
                                        ></source>
                                    </video>
                                </article>
                            );
                        } else {
                            return (
                                <article className="post-section">
                                    <center>
                                        <a class="downloadBtn" href={element.image_versions2.candidates[0].url+"==.jpg"} download={responseObj.full_name + ".jpg"}>
                                            <button class="submitBtn"><i class="fa fa-download"></i> Download Below Image 👇 </button>
                                        </a>
                                    </center>
                                    <img
                                        src={element.image_versions2.candidates[0].url}
                                        className="post-media"
                                        alt="post media"
                                    />
                                </article>
                            );
                        }
                    })
                }
            </section>
        </>
    );
};

export default LoadedPost;
